// Dependencies
import React from 'react';
import { ThemeContext } from '../../components/theme/Theme.jsx';
import radium from 'radium';

function Title(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		fontSize: context.themeManager.value('event-title', 'fontSize', 'font-size-250'),
		lineHeight: context.themeManager.value('event-title', 'lineHeight', 'line-height-100'),
		color: context.themeManager.value('event-title', 'color', 'fg-color-text-highlight'),
		fontWeight: context.themeManager.valueOrDefault('event-title', 'fontWeight', null, '400'),
		margin: '0 0 0.6em',
		wordBreak: 'keep-all',
	};

	return (
		<h1 className="event__title" style={style}>{props.title}</h1>
	);
}

export default radium(Title);
